const formatNumberWithAbbreviation = (value, digits, currentUserLanguage) => {
  let i;
  let valueFormat;
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;

  const valueLookup = [
    { value: 1, symbol: '' },
    // ? Tirar o comentário da linha abaixo para formatar a partir de 6 dígitos
    // { value: 1e3, symbol: 'K' },
    // { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'B' },
    { value: 1e12, symbol: 'T' },
    { value: 1e15, symbol: 'P' },
    { value: 1e18, symbol: 'E' },
  ];

  if (value === null && value !== 0) {
    return '--';
  }

  // Quando o valor é 0, não deve ter casas decimais
  if (value === 0) {
    return '0';
  }

  for (i = valueLookup.length - 1; i > 0; i--) {
    if (value >= valueLookup[i].value) {
      break;
    }
  }

  if (value.toString()[0] === '0') {
    valueFormat = (value / valueLookup[i].value).toFixed(2).replace(rx, '$1');
  } else {
    valueFormat = (value / valueLookup[i].value).toFixed(digits || 0).replace(rx, '$1');
  }

  const valueCultureFormat = new Intl
    .NumberFormat(currentUserLanguage || 'en-US', {
      style: 'decimal',
      minimumFractionDigits: digits || 0,
      maximumFractionDigits: digits || 0,
    })
    .format(Number(valueFormat));

  return valueCultureFormat + valueLookup[i].symbol;
};

export default formatNumberWithAbbreviation;
